<template>
    <div></div>
</template>

<script>
    import constants from '../../constants'

    export default {
        props: {
            consultation: {
                type: Object,
                default: null,
            },
        },

        data: function () {
            return {}
        },

        computed: {},

        methods: {},
    }
</script>
